'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterUpsellProducts = exports.getProductMeasure = undefined;
exports.isLineItemFreeGift = isLineItemFreeGift;
exports.isLineItemMixMatchChild = isLineItemMixMatchChild;
exports.isLineItemMixMatchChildFirst = isLineItemMixMatchChildFirst;
exports.freeGiftIsCurrentlyFree = freeGiftIsCurrentlyFree;
exports.freeGiftCurrentlyHasACost = freeGiftCurrentlyHasACost;

var _constants = require('../../constants');

function isLineItemFreeGift(lineItem) {
  var hasLineItemProperties = lineItem.properties !== null;
  if (!hasLineItemProperties) return false;
  if (lineItem.properties === null) return false;

  var hasAFreeGiftPropertyKey = _constants.FREE_GIFT_CODE_PROPERTY_KEY in lineItem.properties;
  if (!hasAFreeGiftPropertyKey) return false;

  return true;
}

function isLineItemMixMatchChild(lineItem) {
  var hasLineItemProperties = lineItem.properties !== null;
  if (!hasLineItemProperties) return false;
  if (lineItem.properties === null) return false;

  var hasAMixMatchPropertyKey = _constants.MIX_AND_MATCH_CHILD_PROPERTY_KEY in lineItem.properties;
  if (!hasAMixMatchPropertyKey) return false;

  return true;
}

function isLineItemMixMatchChildFirst(lineItem) {
  if (!isLineItemMixMatchChild(lineItem)) return false;

  var hasAMixMatchFirstChildPropertyKey = _constants.MIX_AND_MATCH_CHILD_IS_FIRST_PROPERTY_KEY in lineItem.properties;
  if (!hasAMixMatchFirstChildPropertyKey) return false;

  return true;
}

function freeGiftIsCurrentlyFree(lineItem) {
  if (!isLineItemFreeGift(lineItem)) return false;

  return lineItem.line_price === 0;
}

function freeGiftCurrentlyHasACost(lineItem) {
  if (!isLineItemFreeGift(lineItem)) return false;

  return lineItem.line_price !== 0;
}

var getProductMeasure = exports.getProductMeasure = function getProductMeasure(lineItem) {
  if (lineItem.unit_price_measurement) {
    var _lineItem$unit_price_ = lineItem.unit_price_measurement,
        quantityValue = _lineItem$unit_price_.quantity_value,
        quantityUnit = _lineItem$unit_price_.quantity_unit;

    return '' + parseFloat(quantityValue) + quantityUnit;
  }

  return null;
};

/**
 * Filters upsell products that are not already in the cart
 *
 * @param {Array} lineItems - The line items added to the cart
 * @param {Array} upsellProducts - The list of upsell products
 *
 * @returns {Array} - The filtered upsell items
 */
var filterUpsellProducts = exports.filterUpsellProducts = function filterUpsellProducts(lineItems, upsellProducts) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

  var filteredUpsellItems = [];

  for (var i = 0; i < upsellProducts.length; i++) {
    var upsellProduct = upsellProducts[i];
    var productIsInCart = false;

    for (var j = 0; j < lineItems.length; j++) {
      var lineItem = lineItems[j];

      if (lineItem.id === upsellProduct.id) {
        productIsInCart = true;
        break;
      }
    }

    if (!productIsInCart) {
      filteredUpsellItems.push(upsellProduct);
    }

    if (filteredUpsellItems.length === limit) {
      break;
    }
  }

  return filteredUpsellItems;
};